
(function () {
  'use strict';

  /* ─── Bootstrap ──────────────────────────────────────────────────────────── */
  var cfg = window.EUCartLimitConfig;
  if (!cfg) return;

  var isEU = cfg.euCountries.indexOf(cfg.countryCode) !== -1;
  if (!isEU) return;

  var limitedCats = Object.keys(cfg.categories);

  /* Alte Theme-Setting-Sätze → gleicher kurzer Button-Text wie Locale */
  limitedCats.forEach(function (cat) {
    var msg = String(cfg.categories[cat].msg || '');
    if (/EU-Kunde|EU customer|als EU/i.test(msg)) {
      cfg.categories[cat].msg = 'Limit erreicht (' + cat + ')';
    }
  });

  /* ─── Cart Cache ─────────────────────────────────────────────────────────── */
  var _cartCache   = null;
  var _cartCacheAt = 0;
  var _lastCounts  = null;   // Synchron verwendbar – kein API-Call nötig
  var CACHE_TTL    = 5000;

  function getCart(force) {
    var now = Date.now();
    if (!force && _cartCache && now - _cartCacheAt < CACHE_TTL) {
      return Promise.resolve(_cartCache);
    }
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _cartCache   = cart;
        _cartCacheAt = Date.now();
        return cart;
      });
  }

  function productCategoryMap() {
    var el = document.getElementById('eu-cart-product-categories');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function itemCategory(item, map) {
    var fromProperty = item.properties && item.properties['_eu_cat'];
    if (fromProperty) return fromProperty;
    if (!map) return '';
    return map[String(item.product_id)] || map[item.product_id] || '';
  }

  function countByCategory(cart) {
    var counts = {};
    var map = productCategoryMap();
    limitedCats.forEach(function (c) { counts[c] = 0; });
    cart.items.forEach(function (item) {
      var cat = itemCategory(item, map);
      if (cat && counts.hasOwnProperty(cat)) counts[cat] += item.quantity;
    });
    return counts;
  }

  function overLimit(counts) {
    return limitedCats.some(function (cat) {
      return (counts[cat] || 0) > cfg.categories[cat].limit;
    });
  }

  function limitNote(cat, limit) {
    var tpl = (cfg.messages && cfg.messages.cartNote) || 'Max. {{ limit }} {{ category }}';
    return String(tpl).replace('{{ limit }}', limit).replace('{{ category }}', cat);
  }

  function getBtnLabel(btn) {
    var textEl = btn.querySelector('.loader-button__text');
    return ((textEl ? textEl.textContent : btn.textContent) || '').trim();
  }

  function setBtnLabel(btn, label) {
    var textEl = btn.querySelector('.loader-button__text');
    if (textEl) textEl.textContent = label;
    else btn.textContent = label;
  }

  function originalLabel(btn) {
    return (btn.getAttribute('data-button-content') || btn.dataset.pdpSheetLabel || btn.dataset.euOriginalLabel || '').trim();
  }

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'mini-cart-form' && _lastCounts && overLimit(_lastCounts)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    var form = e.target.closest('form[is="product-form"]');
    if (!form) return;

    var wrapper = form.closest('[data-eu-product-category]');
    if (!wrapper) return;

    var cat   = wrapper.getAttribute('data-eu-product-category');
    var entry = cfg.categories[cat];
    if (!entry) return;

    if (!_lastCounts) return;

    if ((_lastCounts[cat] || 0) >= entry.limit) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);


  var pocketMq = window.matchMedia('(max-width: 999px)');

  function isDockSheetOpener(btn) {
    return pocketMq.matches && btn.hasAttribute('data-pdp-size-sheet-trigger');
  }

  function applyLimitToRoot(root, counts) {
    if (!root || !root.querySelectorAll) return;
    counts = counts || _lastCounts;
    if (!counts) return;

    root.querySelectorAll('[data-eu-product-category]').forEach(function (wrapper) {
      var cat   = wrapper.getAttribute('data-eu-product-category');
      var entry = cfg.categories[cat];
      if (!entry) return;

      var blocked = (counts[cat] || 0) >= entry.limit;

      wrapper.querySelectorAll('[data-product-add-to-cart-button]').forEach(function (btn) {
        /* Nur Mobil-Dock öffnet das Detail. Desktop ist echter Add — Limit gilt sofort. */
        if (isDockSheetOpener(btn)) {
          btn.removeAttribute('data-eu-limit-blocked');
          var openLabel = originalLabel(btn);
          if (openLabel) setBtnLabel(btn, openLabel);
          btn.disabled = false;
          return;
        }
        if (blocked) {
          if (!btn.dataset.euOriginalLabel) {
            var live = getBtnLabel(btn);
            if (live && live !== entry.msg) btn.dataset.euOriginalLabel = live;
          }
          if (btn.dataset.euWasDisabled == null) btn.dataset.euWasDisabled = btn.disabled ? '1' : '0';
          btn.setAttribute('data-eu-limit-blocked', 'true');
          setBtnLabel(btn, entry.msg);
          btn.disabled = true;
        } else {
          btn.removeAttribute('data-eu-limit-blocked');
          var restore = originalLabel(btn);
          if (restore) setBtnLabel(btn, restore);
          if (btn.dataset.euWasDisabled === '0') btn.disabled = false;
        }
      });
    });
  }

  function updateProductButtons(counts) {
    applyLimitToRoot(document, counts);
  }

  function bindFormRerender(form) {
    if (!form || form.dataset.euRerenderBound === '1') return;
    form.dataset.euRerenderBound = '1';
    /* product:rerender bubbelt nicht — am Form patchen, bevor Focal den Desktop-ATC austauscht. */
    form.addEventListener('product:rerender', function (e) {
      var frag = e.detail && e.detail.htmlFragment;
      if (frag) applyLimitToRoot(frag);
    }, true);
  }

  function bindAllProductForms() {
    document.querySelectorAll('form[is="product-form"]').forEach(bindFormRerender);
  }

  /* ══════════════════════════════════════════════════════════════════════════
     CART DRAWER – Warnbanner + Artikel-Highlight + Checkout-Sperre
  ══════════════════════════════════════════════════════════════════════════ */

  function updateCartDrawer(counts) {
    var warningEls = document.querySelectorAll('#eu-cart-limit-warning');
    var checkoutBtns = document.querySelectorAll('.checkout-button[form="mini-cart-form"], button[name="checkout"].checkout-button');

    var violations = {};
    limitedCats.forEach(function (cat) {
      var count = counts[cat] || 0;
      if (count > cfg.categories[cat].limit) {
        violations[cat] = { count: count, limit: cfg.categories[cat].limit };
      }
    });
    var hasViolations = Object.keys(violations).length > 0;

    document.querySelectorAll('#mini-cart line-item[data-eu-cat]').forEach(function (item) {
      var cat = item.getAttribute('data-eu-cat');
      var over = !!violations[cat];
      var price = item.querySelector('.line-item__app-price');
      item.classList.toggle('eu-limit-violation', over);
      if (!price) return;
      if (over) price.setAttribute('data-eu-note', limitNote(cat, violations[cat].limit));
      else price.removeAttribute('data-eu-note');
    });

    if (hasViolations) {
      var note = Object.keys(violations).map(function (cat) {
        return limitNote(cat, violations[cat].limit);
      }).join(' · ');
      warningEls.forEach(function (warningEl) {
        warningEl.textContent = note;
        warningEl.classList.add('is-visible');
      });
      checkoutBtns.forEach(function (checkoutBtn) {
        checkoutBtn.disabled = true;
        checkoutBtn.setAttribute('data-eu-limit-blocked', 'true');
      });
    } else {
      warningEls.forEach(function (warningEl) {
        warningEl.classList.remove('is-visible');
        warningEl.textContent = '';
      });
      checkoutBtns.forEach(function (checkoutBtn) {
        if (checkoutBtn.getAttribute('data-eu-limit-blocked') === 'true') {
          checkoutBtn.disabled = false;
          checkoutBtn.removeAttribute('data-eu-limit-blocked');
        }
      });
    }
  }

  /* ══════════════════════════════════════════════════════════════════════════
     REFRESH
  ══════════════════════════════════════════════════════════════════════════ */

  function applyAll(counts) {
    _lastCounts = counts;
    updateProductButtons(counts);
    updateCartDrawer(counts);
  }

  function refresh(force) {
    getCart(force).then(function (cart) {
      applyAll(countByCategory(cart));
    });
  }

  /* ══════════════════════════════════════════════════════════════════════════
     EVENT LISTENERS
  ══════════════════════════════════════════════════════════════════════════ */

  /* Cart-Änderungen (Theme liefert Cart-Daten oft direkt im Event mit) */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) {
      _cartCache   = e.detail.cart;
      _cartCacheAt = Date.now();
      applyAll(countByCategory(e.detail.cart));
    } else {
      refresh(true);
    }
  });

  function applyLimitNow() {
    if (_lastCounts) applyLimitToRoot(document);
  }

  bindAllProductForms();
  document.addEventListener('variant:changed', applyLimitNow);
  document.addEventListener('variant:change', applyLimitNow);
  if (pocketMq.addEventListener) {
    pocketMq.addEventListener('change', applyLimitNow);
  } else {
    pocketMq.addListener(applyLimitNow);
  }

  new MutationObserver(function (mutations) {
    var addedForm = false;
    var relevant = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (node) {
        if (node.nodeType !== 1) return false;
        if (node.matches && node.matches('form[is="product-form"]')) addedForm = true;
        if (node.querySelector && node.querySelector('form[is="product-form"]')) addedForm = true;
        return node.matches('form[is="product-form"], product-payment-container, [data-product-add-to-cart-button]')
          || (node.querySelector && node.querySelector('[data-product-add-to-cart-button], product-payment-container'));
      });
    });
    if (addedForm) bindAllProductForms();
    if (relevant && _lastCounts) applyLimitNow();
  }).observe(document.body, { childList: true, subtree: true });

  /* Mini-Cart AJAX-Re-Render → Cart-Drawer-State re-applizieren */
  (function () {
    var drawer = document.getElementById('mini-cart');
    if (!drawer) return;
    new MutationObserver(function (mutations) {
      var structural = mutations.some(function (m) {
        return m.type === 'childList' && m.addedNodes.length > 0;
      });
      if (structural && _cartCache) {
        setTimeout(function () { applyAll(countByCategory(_cartCache)); }, 80);
      }
    }).observe(drawer, { childList: true, subtree: true });
  })();

  /* ══════════════════════════════════════════════════════════════════════════
     INIT
  ══════════════════════════════════════════════════════════════════════════ */

  function init() {
    bindAllProductForms();
    refresh(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
